var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPininline = function SvgMapPininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: "#1C72E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6c0 2.148 1.747 5.292 5.22 9.625a1 1 0 0 0 1.56 0C12.254 11.292 14 8.148 14 6A6 6 0 0 0 2 6Zm6-4a4 4 0 0 1 4 4c0 1.403-1.328 3.914-4 7.382C5.328 9.914 4 7.403 4 6a4 4 0 0 1 4-4Z",
    fill: "#1C72E7"
  })));
};
export default SvgMapPininline;